export const primary = {
  primary: {
    color: '{primary.500}',
    inverseColor: '#ffffff',
    hoverColor: '{primary.600}',
    activeColor: '{primary.600}',
  },
};
